import { BaseModel } from "@/models/base/BaseModel";

export class MaintenanceRequest extends BaseModel {
  DateTime: Date;
  dateTime: Date;
  additionalResponse: string;
  category: string;
  categoryId: string;
  completedDateTime: Date;
  friendlyText: string;
  icon: string;
  location: string;
  locationId?: string;
  residentId: string;
  residentName: string;
  status: string;
  vendor?: string;
  vendorId?: string;
  vendorEmail?: string;
  assignee?: string;
  assigneeId?: string;
  assigneeEmail?: string;
  cadence?: string;
  wingId?: string;
  department?: string;
  description?: string;
  name?: string;
  roomId?: string;
  roomName?: string;
  comment?: string;
  priority?: string;
  isSendEmailToVendor?: boolean;
  typeId?: string;
  createdByStaffId?: string;
  createdByStaffName?: string;
}
